import React from "react";
import styles from "./SkeletonLoading.module.scss";

const SkeletonLoading = ({ width = '216px', height = '135px' }) => {

    return (
        <div className={styles.SkeletonLoading} style={{width, height}}>
            <div className={styles.img}></div>
        </div>
    )
}


export default SkeletonLoading;